import { render } from "./InventoryHeader.vue?vue&type=template&id=f367af2c&scoped=true"
import script from "./InventoryHeader.vue?vue&type=script&lang=js"
export * from "./InventoryHeader.vue?vue&type=script&lang=js"

import "./InventoryHeader.vue?vue&type=style&index=0&id=f367af2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f367af2c"]])

export default __exports__